import { render, staticRenderFns } from "./CompEventCard.vue?vue&type=template&id=b3df54c6"
import script from "./CompEventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompEventCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports